interface HeroProps {
  heroBanner: string;
  buttonText: string;
  buttonLink: string;
}

export default function Hero({ heroBanner, buttonText, buttonLink }: HeroProps) {
  return (
    <section className="w-full bg-white py-8">
      <div className="mx-auto max-w-5xl flex flex-col items-center justify-center px-4">
        {/* Centered Image */}
        <img
          src={heroBanner}
          alt="Veneration Wear"
          className="w-full max-w-lg h-auto object-contain"
        />

        {/* CTA Button */}
        <a
          href={buttonLink}
          className="mt-6 inline-block bg-black text-white px-6 py-3 rounded-lg uppercase hover:bg-gray-800 transition-colors"
        >
          {buttonText}
        </a>
      </div>
    </section>
  );
}
